import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import api from 'services/api';
import swal from 'sweetalert';

import { Creators as InterviewsActions, Types as InterviewsTypes } from 'store/ducks/interviews';

function* getInterviewRequest(action) {
  try {
    const { id } = action.payload;
    const url = `search/interviews/${id}`;
    const response = yield call(api.get, url);

    yield put(InterviewsActions.getInterviewSuccess(response.data));
  } catch (error) {
    yield call(swal, 'Não encontrado', 'Não encontramos a entrevista!', 'error');
    yield put(InterviewsActions.getInterviewFailure());
  }
}

function* getInterviewsRequest(action) {
  try {
    const { page, query } = action.payload;
    const filter = query !== null ? `&filter=${query}` : '';
    const url = `search/interviews/page?page=${page}&per=25${filter}`;
    const response = yield call(api.get, url);

    yield put(InterviewsActions.getInterviewsSuccess(response.data));
  } catch (error) {
    yield put(InterviewsActions.getInterviewsFailure());
  }
}

function* createInterviewRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'search/interviews';
    yield call(api.post, url, data);

    yield call(swal, 'Succeso', 'Entrevista criada com sucesso!', 'success');
    yield put(push('/admin/interviews'));
    yield put(InterviewsActions.createInterviewSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível criar a Entrevista!', 'error');
    yield put(InterviewsActions.createInterviewFailure());
  }
}

function* updateInterviewRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `search/interviews/${id}`;
    yield call(api.put, url, data);

    yield call(swal, 'Succeso', 'Entrevista atualizado com sucesso!', 'success');
    yield put(push('/admin/interviews'));
    yield put(InterviewsActions.updateInterviewSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível atualizar a entrevista!', 'error');
    yield put(InterviewsActions.updateInterviewFailure());
  }
}

function* deleteInterviewRequest(action) {
  try {
    const { id } = action.payload;
    const url = `search/interviews/${id}`;
    yield call(api.delete, url);

    yield call(swal, 'Succeso', 'Entrevista removido com sucesso!', 'success');
    yield put(InterviewsActions.getInterviewsRequest(1));
    yield put(InterviewsActions.deleteInterviewSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível remover a Entrevista!', 'error');
    yield put(InterviewsActions.deleteInterviewFailure());
  }
}

function* getInterviewableRequest() {
  try {
    const url = `search/interviews/interviewables`;
    const response = yield call(api.get, url);

    yield put(InterviewsActions.getInterviewableSuccess(response.data));
  } catch (error) {
    yield put(InterviewsActions.getInterviewableFailure());
  }
}

function* sendEmailRequest(action) {
  try {
    const { id } = action.payload;
    const url = `search/interviews/${id}/resendmail`;
    yield call(api.get, url);

    yield call(swal, 'Succeso', 'E-mail enviado com sucesso!', 'success');
    yield put(InterviewsActions.sendEmailSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível enviar o e-mail!', 'error');
    yield put(InterviewsActions.sendEmailFailure());
  }
}

function* createBulkRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'search/interviews/bulk';
    yield call(api.post, url, data);

    yield call(swal, 'Succeso', 'Importação em massa criada com sucesso', 'success');
    yield put(push('/admin/interviews'));
    yield put(InterviewsActions.createBulkSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível criar a importação em massa', 'error');
    yield put(InterviewsActions.createBulkSuccess());
  }
}

function* getInterviewsStatistcsRequest(action) {
  try {
    const url = 'search/interviews/statistics';
    const response = yield call(api.get, url);

    yield put(InterviewsActions.getInterviewsStatistcsSuccess(response.data));
  } catch (error) {
    yield put(InterviewsActions.getInterviewsStatistcsFailure());
  }
}

export default function* saga() {
  yield takeLatest(InterviewsTypes.GET_REQUEST, getInterviewRequest);
  yield takeLatest(InterviewsTypes.GET_LIST_REQUEST, getInterviewsRequest);
  yield takeLatest(InterviewsTypes.CREATE_REQUEST, createInterviewRequest);
  yield takeLatest(InterviewsTypes.UPDATE_REQUEST, updateInterviewRequest);
  yield takeLatest(InterviewsTypes.DELETE_REQUEST, deleteInterviewRequest);
  yield takeLatest(InterviewsTypes.GET_INTERVIEWABLES_REQUEST, getInterviewableRequest);
  yield takeLatest(InterviewsTypes.SEND_EMAIL_REQUEST, sendEmailRequest);
  yield takeLatest(InterviewsTypes.CREATE_BULK_REQUEST, createBulkRequest);
  yield takeLatest(InterviewsTypes.GET_INTERVIEWS_STATISTICS_REQUEST, getInterviewsStatistcsRequest);
}



// WEBPACK FOOTER //
// ./src/store/sagas/interviews.js